import React from "react";
import { Col, Image } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

//STYLES
import * as SlotStyles from "../styles/slot";

function ImageSlot(props) {
    const navigate = useNavigate();

    return (
        <div style={SlotStyles.cardBody}>
            <Image
                src={`/content/photoAndVideoGallery/${props.album}/${props.image}`}
                style={SlotStyles.image}
                onClick={props.onClick.bind(this, props.id)}
            />
        </div>
    );
}

export default ImageSlot;
